import { render, staticRenderFns } from "./AppResetPasswordForm.vue?vue&type=template&id=bc08835a&scoped=true&"
import script from "./AppResetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./AppResetPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./AppResetPasswordForm.vue?vue&type=style&index=0&id=bc08835a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc08835a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
